import React, { useEffect, useState } from "react";
import s from "./style.module.scss";
import Gift from "./icons/Gift";
import Categories, { allCategory } from "./Categories";
import { ICategory } from "./Categories/api/models";
import Tabs, { tabsList } from "./Tabs";
import { ITabItem, tabsType } from "./Tabs/types";
import { IMainGift } from "entities/MainGift/types";
import MainGift from "entities/MainGift";
import { GiftsListApi } from "./api";

const Gifts: React.FC = () => {
  const [activeCategory, setActiveCategory] = useState<ICategory>(allCategory);

  // const [activeTab, setActiveTab] = useState<ITabItem<tabsType>>(tabsList[0]);

  const [loading, setLoading] = useState(true);
  const [giftsList, setGiftsList] = useState<IMainGift[]>([]);

  const getGifts = (category?: number) => {
    GiftsListApi(category)
      .then((res) => {
        setGiftsList(res);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getGifts();
  }, []);

  useEffect(() => {
    if (activeCategory) {
      getGifts(activeCategory.id);
    }
  }, [activeCategory]);

  return (
    <section className={s.gifts}>
      <div className={s.top}>
        <div className={s.image}>
          <Gift />
        </div>

        <h2>Подарки</h2>
      </div>

      <Categories
        activeCategory={activeCategory}
        setActiveCategory={setActiveCategory}
      />

      {/* <Tabs activeTab={activeTab} setActiveTab={setActiveTab} /> */}

      <ul className={s.list}>
        {loading ? (
          <li className={s.title}>Загрузка...</li>
        ) : (
          <>
            {giftsList.length ? (
              giftsList?.map((item, key) => <MainGift {...item} key={key} />)
            ) : (
              <li className={s.title}>Подарков нет</li>
            )}
          </>
        )}
      </ul>
    </section>
  );
};

export default Gifts;
